import React from 'react';

import {updateObject} from 'utils/reducerUtils';
import VerifyCurrentLogin from './VerifyCurrentLogin';

import './styles.scss';
import strings from 'utils/strings';

class AdminInformation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			initiatesLoginChange: false,
			confirmsLoginChange: false,
			newLoginMethod: null,
		};
	}

	validateChangeLogin(loginMethods) {
		let flag = 0;
		if (!loginMethods.includes('Feide')) {
			if (loginMethods.includes('BankID')) {
				flag = flag + 1;
			}
			if (loginMethods.includes('Legacy')) {
				flag = flag + 1;
			}
			if (loginMethods.includes('BankIDMobile')) {
				flag = flag + 1;
			}
		}

		if (flag === 1) {
			return true;
		}

		return false;
	}

	render() {
		const testAdmin = this.props.testAdmin;
		const isSuperAdmin = this.props.isSuperAdmin;
		const loginMethods = this.props.loginMethods;
		let loginMethodsInfo = '';
		for (let i = 0; i < loginMethods.length; i++) {
			if (loginMethods[i + 1]) {
				loginMethodsInfo =
					loginMethodsInfo + loginMethods[i].toString() + ', ';
			} else {
				loginMethodsInfo =
					loginMethodsInfo + loginMethods[i].toString();
			}
		}

		return (
			<div className="lit-subscription-main">
				<div className="tab-heading">
					<h3 className="lit-page-title">
						{isSuperAdmin
							? `${`${testAdmin.firstName} ${testAdmin.lastName}`} ${
									strings.auth.referalinformation
							  }`
							: strings.auth.myinformation}
					</h3>
				</div>
				<form
					className="register-form"
					onSubmit={(event) => {
						event.preventDefault();
						const testAdminResult = updateObject(testAdmin);
						this.props.onSaveTestAdmin(testAdminResult);
					}}
				>
					<br />

					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-firstName"
						>
							{strings.common.firstname}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-firstName"
							name="firstName"
							onChange={this.props.onHandleUpdateTestAdminEvent}
						placeholder={strings.common.placeholderFirstName}
							required
							type="text"
							value={testAdmin.firstName || ''}
						/>
					</div>
					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-lastName"
						>
							{strings.common.lastname}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-lastName"
							name="lastName"
							onChange={this.props.onHandleUpdateTestAdminEvent}
						placeholder={strings.common.placeholderLastName}
							required
							type="text"
							value={testAdmin.lastName || ''}
						/>
					</div>
					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-organization"
						>
							{strings.auth.shcool_or_company}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-organization"
							name="organization"
							onChange={this.props.onHandleUpdateTestAdminEvent}
						placeholder={strings.common.placeholderOrganization}
							type="text"
							value={testAdmin.organization || ''}
						/>
					</div>
					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-email"
						>
							{strings.common.email}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-email"
							name="email"
							onChange={this.props.onHandleUpdateTestAdminEvent}
							placeholder={strings.common.placeholderEmail}
							required
							type="email"
							value={testAdmin.email || ''}
						/>
					</div>

					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-phone"
						>
							{strings.common.telephone}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-phone"
							name="phone"
							onChange={this.props.onHandleUpdateTestAdminEvent}
							placeholder={strings.common.placeholderPhoneNumber}
							required
							type="tel"
							value={testAdmin.phone || ''}
						/>
					</div>
					<div className="lit-input inline">
						<label
							className="lit-input__label wide"
							htmlFor="test-admin-modal-loginMethod"
						>
							{loginMethods.length > 1
								? strings.auth.loginmethods
								: strings.auth.loginmethod}
						</label>
						<input
							className="lit-input__field"
							id="test-admin-modal-loginMethod"
							name="loginMethod"
							disabled
							type="tel"
							value={
								loginMethodsInfo === 'custom'
									? strings.auth.password
									: loginMethodsInfo
							}
						/>
					</div>
					{console.log('loginMethodsInfo =>>>', loginMethodsInfo)}
					<div className="lit-input-save">
						<button className="lit-btn bg-primary">
							{`${strings.common.save}`}
						</button>
					</div>
				</form>
				<br />
				{this.validateChangeLogin(loginMethods) &&
					!loginMethods.includes('Feide') && (
						<div className="lit-change-loginMethod">
							<p>
								{strings.formatString(
									strings.auth.loginmethod_change_description,
									loginMethods.length > 1
										? strings.auth.loginmethods
										: strings.auth.loginmethod,
									loginMethodsInfo
								)}
							</p>
							<div>
								<input
									className="lit-change-login"
									id={'feide'}
									name="password"
									onChange={() => {
										this.setState({
											initiatesLoginChange: true,
											newLoginMethod: 'feide',
										});
									}}
									type="radio"
								/>
								<label
									className="lit-login-label"
									htmlFor={'feide'}
								>
									{strings.auth.changeToFeide}
								</label>
							</div>
							<br></br>
							<div>
								<input
									className="lit-change-login"
									id={'password'}
									name="password"
									disabled
									onChange={() => {
										this.setState({
											initiatesLoginChange: true,
											newLoginMethod: 'password',
										});
									}}
									type="radio"
								/>
								<label
									className="lit-login-label"
									htmlFor={'password'}
								>
									{strings.auth.chageToPassword}
								</label>
							</div>
							<br></br>
							{this.state.initiatesLoginChange && (
								<div className="lit-input">
									<button
										className="lit-btn bg-primary"
										onClick={() => {
											this.setState({
												confirmsLoginChange: true,
											});
										}}
									>
										{`${strings.common.confirm}`}
									</button>
								</div>
							)}
						</div>
					)}
				{this.state.confirmsLoginChange && (
					<div>
						<VerifyCurrentLogin
							closeWindow={() => {
								this.setState({confirmsLoginChange: false});
							}}
							regToken={testAdmin.regToken}
							testAdmin={testAdmin}
							chosenMethod={this.state.newLoginMethod}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default AdminInformation;
